import { render, staticRenderFns } from "./ReusableDialog.vue?vue&type=template&id=21fb488c&scoped=true"
import script from "./ReusableDialog.vue?vue&type=script&lang=js"
export * from "./ReusableDialog.vue?vue&type=script&lang=js"
import style0 from "./ReusableDialog.vue?vue&type=style&index=0&id=21fb488c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fb488c",
  null
  
)

export default component.exports